import { createFileRoute } from "@tanstack/react-router";
import {
  ColorPage,
  colorLoader,
  colorHeadDa,
  ColorErrorComponent,
  ColorNotFoundComponent,
} from "@/pages/ColorPage";

export const Route = createFileRoute("/farver/$slug")({
  loader: colorLoader,
  head: colorHeadDa,
  component: ColorPage,
  errorComponent: ColorErrorComponent,
  notFoundComponent: ColorNotFoundComponent,
});
